
export const ALL_PAYMENTS_STATUS = [
  {
    code: "1",
    name: "Created "
  },
  {
    code: "2",
    name: "Processed"
  },
  {
    code: "3",
    name: "Archived"
  }

];

export const ALL_PAYMENTS_MODES = [
  {
    code: "1",
    name: "Automatic"
  },
  {
    code: "2",
    name: "Manual"
  },
  {
    code: "3",
    name: "Internal"
  }

];

export const ALL_PAYMENTS_ORG_UNIT = [
  {
    code: "USA",
    name: "USA"
  },
  {
    code: "Europe",
    name: "Europe"
  }


];
